import Node from '../structures/Node'
import {computeLevels} from './NodeLevelService';
import config from  '../config/GraphViewConfig'
import graphConfig from '../../../config'
import {graph} from "./GraphService";
import {computeCoordinates} from "./NodeCoordinateService";

function prepareNodes(nodesData,edgesData,preset) {

    const nodes = nodesData.map(node => new Node(node))

    computeNodesSizes(nodes)

    if(!preset) {
        graph.createAdjacencyList(nodes,edgesData) //adjacency list

        computeLevels(nodes,graph.adj)
        computeCoordinates(nodes,graph.adj)
    }else {
        // TODO handle node preparation from saved preset
    }

    return nodes;
}


function computeNodesSizes(nodes) {
    nodes.forEach(node => {
        /*
         * A transfer node is measured differently because it is shaped
         * differently: no row of buttons beneath it, so none of the height they
         * need, and a fixed width since nothing inside it can grow.
         */
        if (node.data.nodeType === graphConfig.nodeTypes.operatorTransfer) {
            node.height = config.design.node.transfer.height
                + config.design.node.nodeAndNodePortGap
                + config.design.node.port.height
            node.width = config.design.node.transfer.width
            return
        }

        node.height = config.design.node.height + config.design.node.nodeAndNodePortGap + config.design.node.port.height + config.design.node.button.height + config.design.node.nodeAndButtonContainerGap
        node.width = Math.max(
            config.design.node.width,
            (node.data.buttons.length + 1) * config.design.node.button.width + node.data.buttons.length * config.design.node.buttonsGap
        )
    })
}

export { prepareNodes }


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/services/NodeService.js